/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutoCloseConfig
 */
export interface AutoCloseConfig {
    /**
     * 
     * @type {boolean}
     * @memberof AutoCloseConfig
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof AutoCloseConfig
     */
    closeDays?: number;
}

export function AutoCloseConfigFromJSON(json: any): AutoCloseConfig {
    return AutoCloseConfigFromJSONTyped(json, false);
}

export function AutoCloseConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoCloseConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'closeDays': !exists(json, 'closeDays') ? undefined : json['closeDays'],
    };
}

export function AutoCloseConfigToJSON(value?: AutoCloseConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'closeDays': value.closeDays,
    };
}

